{
    "PromptDeletereport": "Tem certeza de que deseja excluir?",
    "PromptDeletereports": "Tem certeza de que deseja excluir permanentemente os relatórios selecionados?",
    "PromptEmptyrecyclebin": "Tem certeza de que deseja excluir permanentemente todos os relatórios da lixeira?",
    "PromptRemovereport": "Tem certeza de que deseja remover este relatório?",
    "PromptReportswillbedeletedpermanently": "Os relatórios serão excluídos permanentemente e não poderão ser restaurados.",
    "AreYouSureDelete": "Tem certeza de que deseja excluir?",
    "AreYouSureRemove": "Tem certeza de que deseja remover este relatório?",
    "LanguagePrompt_PromptConfirm": "confirme",
    "LanguagePrompt_PromptCancel": "Cancelar",
    "NAME": "LanguagePrompt"
}